import {Rectangle} from 'pixi.js';
import React, {FunctionComponent} from 'react';
import {_ReactPixi} from '@inlet/react-pixi';
import {CoreSprite, RichText, ButtonCustom} from '@gongxigames/framework/core/fragments/react';

export type ButtonStartProps = Omit<_ReactPixi.IContainer, 'click'> & {
    press: null | (() => void);
};

const HIT_AREA = new Rectangle(-301, -110, 602, 220);

export const ButtonStart: FunctionComponent<ButtonStartProps> = (props) => {
    return (
        <ButtonCustom name='startButton' {...props} hitArea={HIT_AREA}>
            <ButtonCustom.Idle>
                <CoreSprite src='preloader_button_normal' anchor={0.5}/>
                <RichText id='buttonStart' style='LoadingScreenButton' y={-10} maxWidth={400}/>
            </ButtonCustom.Idle>
            <ButtonCustom.Hover>
                <CoreSprite src='preloader_button_focused' anchor={0.5}/>
                <RichText id='buttonStart' style='LoadingScreenButton' y={-10} maxWidth={400}/>
            </ButtonCustom.Hover>
            <ButtonCustom.Pressed>
                <CoreSprite src='preloader_button_pressed' anchor={0.5}/>
                <RichText id='buttonStart' style='LoadingScreenButtonPressed' y={-6} maxWidth={375}/>
            </ButtonCustom.Pressed>
        </ButtonCustom>
    );
};
